<template>
  <div class="p-4">
    <Button class="my-2" @click="createUser()">کاربر جدید</Button>
    <table class="text-white w-full divide-y divide-gray-400 text-sm">
      <tr class="text-right">
        <th class="py-2">نام</th>
        <th>نام کاربری</th>
        <th>رمز</th>
        <th>نقش</th>
        <th>عملیات</th>
      </tr>
      <tr v-for="user in users"
          :key="user.username"
          class="text-xs" :class="{'bg-red-500/50' : !user.enable}">
        <td class="py-2">{{ user.fullName }}</td>
        <td>{{ user.username }}</td>
        <td>{{ user.password }}</td>
        <td>{{ user.role }}</td>
        <td>
          <button class="text-xs rounded bg-yellow-500 px-2 py-0.5" @click="editUser(user)">
            ویرایش
          </button>
        </td>
      </tr>
    </table>
  </div>

  <!--  Edit Modal -->
  <transition name="fade">
    <div class="flex justify-center items-center fixed top-0 bg-gray-500/60 h-full w-full left-0 right-0 z-20"
         v-if="userModal" @click="userModal = !userModal">
      <div class="bg-gray-800 rounded-lg w-3/4 p-4" @click.stop>
        <h1 class="text-center text-white">{{ editMode ? 'ویرایش کاربر' : 'کاربر جدید' }}</h1>
        <form action="" class="mt-4" @submit.prevent="editMode ? updateUser() : submitUser()">
          <Input type="text" placeholder="نام" v-model="user.fullName" required/>
          <Input class="mt-2" type="tel" placeholder="نام کاربری" v-model="user.username" v-if="!editMode" required/>
          <Input class="mt-2" type="tel" placeholder="رمز" v-model="user.password" required/>
          <select class="mt-2 rounded-xl p-2 w-full" v-model="user.role_Id">
            <option value="" disabled>نقش</option>
            <option v-for="role in roles"
                    :key="role.id"
                    :value="role.id">{{ role.rolE_NAME }}
            </option>
          </select>
          <div class="flex items-center mt-2 text-white">
            <label for="active">فعال</label>
            <input class="w-full" type="checkbox" v-model="user.enable"/>
          </div>
          <Button class="mt-4">ثبت</Button>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import {createUser, getRolesList, getUsersList, updateUser} from "../../API/API";
import Input from "../../components/Input";
import Button from "../../components/General/Button";
import Vue from "vue";

export default {
  name: "Users",
  components: {Button, Input},
  data() {
    return {
      users: [],
      userModal: false,
      editMode: false,
      roles: [],
      user: {
        fullName: '',
        password: '',
        username: '',
        role_Id: '',
        enable: '',
      }
    }
  },
  async created() {
    this.users = (await getUsersList()).data.result
    this.roles = (await getRolesList()).data.result
  },
  methods: {
    createUser() {
      this.editMode = false
      this.user = {role_Id: ''}
      this.userModal = true
    },
    editUser(user) {
      this.editMode = true
      user.enable = user.enable === 1
      this.user = user
      this.userModal = true
    },
    submitUser() {
      this.user.enable = this.user.enable ? 1 : 0
      createUser(this.user)
          .then(async resp => {
            this.$swal({
              icon: 'success',
              title: 'موفق',
              text: resp.data.message,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
            this.users = (await getUsersList()).data.result
          })
          .catch(err => {
            Vue.swal({
              icon: 'error',
              title: 'خطا',
              text: err.response.data.message,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
          })
          .finally(() => {
            this.userModal = false
          })
    },
    updateUser() {
      this.user.enable = this.user.enable ? 1 : 0
      updateUser(this.user)
          .then(async resp => {
            this.$swal({
              icon: 'success',
              title: 'موفق',
              text: resp.data.message,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
            this.users = (await getUsersList()).data.result
          })
          .catch(err => {
            Vue.swal({
              icon: 'error',
              title: 'خطا',
              text: err.response.data.message,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
          })
          .finally(() => {
            this.userModal = false
          })
    }
  }
}
</script>

<style scoped>

</style>